import SumoLogger from 'sumo-logger';
import config from 'config';

const baseUrl = 'https://endpoint1.collection.us2.sumologic.com/receiver/v1/http';

const options = {
  endpoint: `${baseUrl}/${config.sumo.token}`,
  sendErrors: true,
  interval: 1e3,
  batchSize: 100e3,
  sourceName: 'web-react',
  sourceCategory: config.sumo.sourceCategory,
};

export const sumoLogger = new SumoLogger(options);
